export default "__VITE_ASSET__C7vB0htz__"